import { Component, effect, Inject, Signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from "@angular/material/radio";
import { MAT_LUXON_DATE_FORMATS, MatLuxonDateModule, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { discountTypes, MY_DATE_FORMATS, PredefinedDiscounts } from '../../../domain/registrator';
import { DatePipe } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-promocode-gen',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatLuxonDateModule
  ],
  providers: [
    provideLuxonDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ],
  templateUrl: './promocode-gen.component.html',
  styleUrl: './promocode-gen.component.scss'
})
export class PromocodeGenComponent {
  form: FormGroup;
  predefinedDiscounts = PredefinedDiscounts;
  discountTypeOptions = discountTypes;
  readonly discountTypeSignal!: Signal<string>;
  readonly percentDiscountSignal!: Signal<string>;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PromocodeGenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      numberOfCodes: [1, [Validators.required, Validators.min(1)]],
      comment: [''],
      maxUses: [1, [Validators.required, Validators.min(0)]],
      validUntil: [null, Validators.required],
      discountType: ['PERCENT', Validators.required],
      percentDiscount: [0],
      customPercentDiscount: [0],
      fixedAmountDiscount: [0]
    });
    this.discountTypeSignal = toSignal(this.form.get('discountType')!.valueChanges,
      { initialValue: this.form.get('discountType')!.value });
    this.percentDiscountSignal = toSignal(this.form.get('percentDiscount')!.valueChanges,
      { initialValue: this.form.get('percentDiscount')!.value });
      
    effect(() => {
      const discountType = this.discountTypeSignal();
      console.log('Discount type effect: ', discountType);
      this.setValidators();
    });

    effect(() => {
      const percentDiscount = this.percentDiscountSignal();
      console.log('Percent discount effect: ', percentDiscount);
      this.setValidators();
    });
  }

  private setValidators(): void {
    if (this.form.value.discountType === 'PERCENT') {
      this.form.get('percentDiscount')!.setValidators([Validators.required]);
      if (this.form.value.percentDiscount === 'custom') {
        this.form.get('customPercentDiscount')!.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      }
    } else if (this.form.value.discountType === 'FIXED_AMOUNT') {
      this.form.get('fixedAmountDiscount')!.setValidators([Validators.required, Validators.min(0)]);
    } else {
      this.form.get('percentDiscount')!.clearValidators();
      this.form.get('customPercentDiscount')!.clearValidators();
      this.form.get('fixedAmountDiscount')!.clearValidators();
    }
    this.form.get('percentDiscount')!.updateValueAndValidity({ emitEvent: false });
    this.form.get('customPercentDiscount')!.updateValueAndValidity({ emitEvent: false });
    this.form.get('fixedAmountDiscount')!.updateValueAndValidity({ emitEvent: false });
  }

  get discountValue(): number | null {
    console.log('Calculating discount value for code type:', this.form.value.discountType);
    if (this.form.value.discountType === 'PERCENT') {
      return this.form.value.percentDiscount === 'custom'
        ? this.form.value.customPercentDiscount
        : this.form.value.percentDiscount;
    } else if (this.form.value.discountType === 'FIXED_AMOUNT') {
      return this.form.value.fixedAmountDiscount;
    }
    return null;
  }

  submit(): void {
    if (this.form.valid) {
      const datePipe = new DatePipe('en-US');
      const payload = {
        numberOfCodes: this.form.value.numberOfCodes,
        comment: this.form.value.comment,
        validUntil: datePipe.transform(this.form.value.validUntil, 'yyyy-MM-dd'),
        discountValue: this.discountValue,
        discountType: this.form.value.discountType,
        maxUses: this.form.value.maxUses
      };
      this.dialogRef.close(payload);
    }
  }
}
